import store from './store'
import { rules } from './config'
const req = require.context('@/components/component-Svgm/svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys()
const re = /\.\/(.*)\.svg/

//获取浏览器窗口的宽高
export function getWindowMess() {
    let clientHeight = document.documentElement.clientHeight;
    let clientWidth = document.documentElement.clientWidth;
    store.commit({
        type: "setWindowBtn",
        clientHeight: clientHeight,
        clientWidth: clientWidth
    })
}

//动态重置路由页面的宽度
export function setRouterNav() {
    store.commit({
        type: "setResetrouterNavWidth",
        ResetrouterNavWidth: store.state.routerNavWidth,
    })
}

/**
 * 
 * @tag date dateTime  获取指定时间 支持属性： yyyy-MM-dd HH:mm:ss ms week 
 * @param { 时间对象 } date 
 * @param { 转换时间的格式 } format 
 * @param { 是否补零 } isPad 
 */
export function getDateFun(date, format, isPad) {
    // 将时间进行归一化
    function _dateFormat(format) {
  
      if (typeof format == 'Funtion') {
        return format;
      }
  
      if (format == 'mounth') {
        format = 'yyyy-MM-dd';
      }
  
      if (format == 'date') {
        format = 'yyyy-MM-dd HH:mm:ss';
      }
  
      const formatFun = (dateInfo) => {
        const { yyyy, MM, dd, HH, mm, ss, ms, week } = dateInfo;
  
        return format.replaceAll('yyyy', yyyy)
          .replaceAll('MM', MM)
          .replaceAll('dd', dd)
          .replaceAll('HH', HH)
          .replaceAll('mm', mm)
          .replaceAll('ss', ss)
          .replaceAll('ms', ms)
          .replaceAll('week', week)
      }
  
      return formatFun;
    }
  
  
    let dateFormatFun = _dateFormat(format);
  
    let week = ["日", "一", "二", "三", "四", "五", "六"];
  
    let dateInfo = {
      yyyy: date.getFullYear(),
      MM: date.getMonth() * 1 + 1,
      dd: date.getDate(),
      HH: date.getHours(),
      mm: date.getMinutes(),
      ss: date.getSeconds(),
      ms: date.getTime(),
      week: week[date.getDay()]
    }
  
    // 补零
    if (isPad) {
  
      let keyArr = Object.keys(dateInfo);
  
      for (let key in dateInfo) {
        if (key == 'week') continue;
        let len = key.length;
        dateInfo[key] = (dateInfo[key] + '').padStart(len, '0')
      }
      // console.log('date',dateInfo)
    }
  
    return dateFormatFun(dateInfo);
}

//获取日期
export function getDateTime() {
    var nowdate = new Date();
    var year = nowdate.getFullYear(),
        month = nowdate.getMonth() + 1,
        date = nowdate.getDate(),
        day = nowdate.getDay(),
        week = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
        h = nowdate.getHours(),
        m = nowdate.getMinutes(),
        s = nowdate.getSeconds(),
        hour = h < 10 ? "0" + h : h
    m = m < 10 ? "0" + m : m
    s = s < 10 ? "0" + s : s
    return year + "年" + month + "月" + date + "日 " + week[day] + " " + hour + ":" + m + ":" + s;
}

//获取日期和时间 不含周几
export function getDateAndTime(nowDate) {
    var nowdate = new Date(nowDate);
    var year = nowdate.getFullYear(),
        month = nowdate.getMonth() + 1,
        date = nowdate.getDate(),
        day = nowdate.getDay(),
        week = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
        h = nowdate.getHours(),
        m = nowdate.getMinutes(),
        s = nowdate.getSeconds(),
        hour = h < 10 ? "0" + h : h
    m = m < 10 ? "0" + m : m
    s = s < 10 ? "0" + s : s
    return year + "-" + ((month + "").length == 1 ? "0" + month : month) + "-" + ((date + "").length == 1 ? "0" + date : date) + " " + hour + ":" + m + ":" + s;
}

//获取日期不含时间
export function getDate(nowdate) {
    // var nowdate = new Date();
    var year = nowdate.getFullYear(),
        month = nowdate.getMonth() + 1,
        date = nowdate.getDate(),
        day = nowdate.getDay(),
        week = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
        h = nowdate.getHours(),
        m = nowdate.getMinutes(),
        s = nowdate.getSeconds(),
        hour = h < 10 ? "0" + h : h
    m = m < 10 ? "0" + m : m
    s = s < 10 ? "0" + s : s
    return year + "-" + ((month + "").length == 1 ? "0" + month : month) + "-" + ((date + "").length == 1 ? "0" + date : date) + " ";
}

//获取日期不含日期
export function getTime(nowdate) {
    // var nowdate = new Date();
    var year = nowdate.getFullYear(),
        month = nowdate.getMonth() + 1,
        date = nowdate.getDate(),
        day = nowdate.getDay(),
        week = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
        h = nowdate.getHours(),
        m = nowdate.getMinutes(),
        s = nowdate.getSeconds(),
        hour = h < 10 ? "0" + h : h
    m = m < 10 ? "0" + m : m
    s = s < 10 ? "0" + s : s
    return ((hour + "").length == 1 ? "0" + hour : hour) + ":" + ((m + "").length == 1 ? "0" + m : m) + ":" + ((s + "").length == 1 ? "0" + s : s);
}

//获取icon图片的尾缀
export function Iconimg() {
    let arrayList = []
    requireAll(req).map(i => {
        arrayList.push(i.match(re)[1])
    })
    return arrayList
}

//数组对象去重 
export function removal(tempArr) {
    let newArr = [];
    for (let i = 0; i < tempArr.length; i++) {
        if (newArr.indexOf(tempArr[i].menuSonID) == -1) {
            newArr.push(tempArr[i].menuSonID)
        } else {
            tempArr.splice(i, 1);
        };
    };
    return tempArr;
}

//数字数组排序
export function arraySort(arr) {
    for (var i = 0; i < arr.length - 1; i++) {
        // 控制每轮比较
        for (var j = 0; j < arr.length - i - 1; j++) {
            // 前面的数大于后面的数交换位置
            if (arr[j] > arr[j + 1]) {
                let temp = arr[j];
                arr[j] = arr[j + 1];
                arr[j + 1] = temp
            }
        }
    }
    return arr
}

//非空验证
export function isEmpty(rule, value, callback) {
    if (!value) {
        return callback(new Error(store.state.emptyText));
    }
    callback()
}

//验证手机号"不可"为空
export function checkPhone(rule, value, callback) {
    if (!rules.NONEMPTY.test(value)) {
        return callback(new Error('手机号不能为空'));
    } else {
        if (rules.PHONE.test(value)) {
            callback();
        } else {
            return callback(new Error('请输入正确的手机号'));
        }
    }
}

//验证手机号"可"为空
export function checkPhoneEn(rule, value, callback) {
    if (!rules.NONEMPTY.test(value)) {
        return callback();
    } else {
        if (rules.PHONE.test(value)) {
            callback();
        } else {
            return callback(new Error('请输入正确的手机号'));
        }
    }
}

//验证用户账号工厂
export function checkAccout(rule, value, callback) {
    if (!rules.NONEMPTY.test(value)) {
        return callback(new Error("账号不可为空"));
    } else {
        if (rules.ENGCHENUMBER.test(value)) {
            callback();
        } else {
            return callback(new Error('账号必须为6~10位由数字或字母'));
        }
    }
}

export function checkAccoutF(rule, value, callback) {
    if (!rules.NONEMPTY.test(value)) {
        return callback(new Error("账号不可为空"));
    } else {
        if (rules.ENGCHENUMBEB.test(value)) {
            callback();
        } else {
            return callback(new Error('账号必须为6~12位由数字或字母'));
        }
    }
}

//验证域名
export function checkHttp(rule, value, callback) {
    if (!rules.NONEMPTY.test(value)) {
        callback();
    } else {
        if (rules.HTTPRULS.test(value)) {
            callback();
        } else {
            return callback(new Error('域名格式出错'));
        }
    }
}

//验证域名
export function checkInterface(rule, value, callback) {
    if (!rules.NONEMPTY.test(value)) {
        callback();
    } else {
        if (rules.ENGCHEN.test(value)) {
            callback();
        } else {
            return callback(new Error('只允许输入数字英文'));
        }
    }
}

//获取URL参数值
export function getParms() {
    var url = location.href; //取得整个地址栏
    var num = url.indexOf("?")
    url = url.substr(num); //取得所有参数
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;

}

export function changeKay(objAry) {
    if (objAry != null) {
        objAry.forEach((item) => {
            item["companyId"] = item.currentDepart.companyId
            item["createTime"] = item.currentDepart.createTime
            item["departStatus"] = item.currentDepart.departStatus
            item["descr"] = item.currentDepart.descr
            item["id"] = item.currentDepart.id
            item["isDel"] = item.currentDepart.isDel
            item["level"] = item.currentDepart.level
            item["name"] = item.currentDepart.name
            item["operator"] = item.currentDepart.operator
            item["parentId"] = item.currentDepart.parentId
            item["unit_id"] = item.currentDepart.unit_id
            item["updateTime"] = item.currentDepart.updateTime
            delete item.currentDepart;
            changeKay(item.childDeparts);
        });
        console.log(objAry)
    }
}


// 导出文件实体方法
export const downFile = (stream, name, suffix) => {
    const DOWNLOAD_TYPE_MAP = {
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        pdf: 'application/pdf'
    };
    const fileName = name + '.' + suffix;
    const blob = new Blob([stream], {
        type: DOWNLOAD_TYPE_MAP[suffix]
    });
    let link = document.createElement('a');
    document.body.appendChild(link);
    link.href = (window.URL || window.webkitURL).createObjectURL(blob);
    link.setAttribute('download', fileName);
    link.click();
    document.body.removeChild(link);
    (window.URL || window.webkitURL).revokeObjectURL(link.href);
}


//截取 - 以前的文字
export function deviceName(value){
    if(!value){
		return ""
	 }
	if(value.indexOf('-')==-1){
		return value
	}
    return  value.slice(0,value.indexOf('-'))
}

